import { useState, useCallback } from 'react';

 const useDelete = (baseUrl, options = {}) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const deleteData = useCallback(
    async (id) => {
      setIsLoading(true);
      try {
        const urlWithId = `${baseUrl}/${id}`; 
        console.log("Deleting at:", urlWithId);

        const response = await fetch(urlWithId, {
          ...options,
          method: 'DELETE', 
          headers: {
            'Content-Type': 'application/json',
            ...(options.headers || {}),
          },
        });

        const result = await response.json();
        console.log('Delete response:', result);

        if (!response.ok) {
          throw new Error(result.message || 'Failed to delete the resource');
        }

        setData(result);
        setError(null);
      } catch (err) {
        setError(err.message || 'Something went wrong during delete');
      } finally {
        setIsLoading(false);
      }
    },
    [baseUrl, options]
  );

  return { data, error, isLoading, deleteData };
};

export default useDelete